/**
 * 系统管理 菜单管理
 */
<template>
  <div class="main">
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>考核数据</el-breadcrumb-item>
      <el-breadcrumb-item>工程项目</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
        <el-form class="user-search">
          <el-form-item>
            <el-button size="small" type="primary" @click="goback">返回</el-button>
          </el-form-item>
        </el-form>
        <div class="titlelist"><div class="icons"></div>工程项目信息</div>
		<div class="listout">
			
			<div class="list">
				<div class="listleft">项目名称：{{list.name}}</div>
			</div>
			<div class="list">
				<div class="listleft" v-if="list.projectCategory==1">项目类别：工程项目</div>
			</div>
			<div class="list">
				<div class="listleft" v-if="list.projectCategory==2">项目类别：煤改电</div>
			</div>
			<div class="list">
				<div class="listleft" v-if="list.projectCategory==3">项目类别：地产</div>
			</div>
			<div class="list">
				<div class="listleft">项目使用单位：{{list.projectUser}}</div>
			</div>
			
			
		</div>
		
		<div class="listout">
			<div class="list">
				<div class="listleft">项目联系人：{{list.linkman}}</div>
			</div>
			<div class="list">
				<div class="listleft">联系人电话：{{list.phoneNumber}}</div>
			</div>
			<div class="list">
				<div class="listleft">预估机型：{{list.estimatedModel}}</div>
			</div>
			<div class="list">
				<div class="listleft">预估数量：{{list.estimatedQuantity}}</div>
			</div>
			
		</div>
		
		<div class="listout">
			<div class="list">
				<div class="listleft">预计招标/采购时间：{{list.estimatedTenderTime}}</div>
			</div>
			<div class="list">
				<div class="listleft">预估施工时间：{{list.estimatedBuildTime}}</div>
			</div>
			<div class="list">
				<div class="listleft">省份：{{list.province}}{{list.city}}</div>
			</div>
			
		</div>
		<div class="listout">
			<div class="list">
				<div class="listleft">是否成交：{{list.dealStatus==1?'是':'否'}}</div>
			</div>
			<div class="list">
				<div class="listleft">成交时间：{{list.dealTime}}</div>
			</div>
			
			
		</div>
		
		<div class="listout">
			
			<div class="list">
				<div class="listleft">跟踪情况描述：{{list.trackDesc}}</div>
			</div>
			
		</div>
		
		<div class="listout">
			<div class="list">
				<div class="listleft">跟踪状态：{{list.trackStatus==1?'公司直接跟踪':'配合经销商跟踪'}}</div>
			</div>
			<div class="list">
				<div class="listleft">经销商名称：{{list.dealerName}}</div>
			</div>
			<div class="list">
				<div class="listleft">经销商联系方式：{{list.dealerPhoneNumber}}</div>
			</div>
			<div class="list">
				<div class="listleft">是否参与投标：{{list.tenderStatus==1?'是':'否'}}</div>
			</div>
			
		</div>
		
		
		
		
		
		<div class="titlelist"><div class="icons"></div>项目图片</div>
		<div class="listout">
			<div class="lists">
				  <div class="imglist" v-for="(item,index) in resultFilelist">
					  <img :src="item.url" @click="clickimg(item.fileTemporaryUrl)" />
				  </div>
			</div>
			
		</div>
		
		
		
		
		
		<el-dialog
		  title=""
		  :visible.sync="centerDialogVisible"
		  width="70%"
		  center>
		  <img class="imgUrls" :src="imgUrls"/>
		  <span slot="footer" class="dialog-footer">
		    <el-button @click="centerDialogVisible = false">取 消</el-button>
		    <el-button type="primary" @click="centerDialogVisible = false">确 定</el-button>
		  </span>
		</el-dialog>
		
		
      </div>
    </template>

    <script>
	// 导入请求方法
	import { uploadFile } from '../../api/axiosFun';
    import {
      getProjectInfoById,
      } from '../../api/knowledgeFun'
    import Pagination from '../../components/Pagination'

  
    import {evaluateUpload }from '@/api/auth';
    import { setCookie, getCookie, delCookie } from '../../utils/util'



    export default {
      data() {
        return {
          loading: false, //是显示加载
          list:[],
		  resultFilelist:[],
		  resultFilelist1:[],
		  lists:[],
		  fileList: [],
		  centerDialogVisible: false,
		  imgUrls:''
         
        }
      },
      // 注册组件
      components: {
        Pagination
      },

      /**
       * 数据发生改变
       */
      watch: {},

      /**
       * 创建完毕
       */
      created() {
        //this.getData(this.formProInfo)

      },
      mounted(){
		  this.id = this.$route.query.id
		  this.handleEdit()
		  
      },
      beforeDestroy(){
        // document.removeEventListener("paste",this.handlePaste);
      },
      /**
       * 里面的方法只有被调用才会执行
       */
      methods: {
		clickimg(e){
			this.imgUrls = e
			this.centerDialogVisible  = true
		},
		  //显示编辑界面
		  handleEdit: function() {
		    let _this = this
		   
		   getProjectInfoById(this.id).then(res => {
		       console.log(res)
		       this.loading = false
		       if (res.success == false) {
		         this.$message({
		           type: 'info',
		           message: res.msg+'TraceId:'+res.traceId
		         })
		       } else {
		         console.log(res)
		         this.list = res.data
				  this.resultFilelist = this.list.pictureInfoList
					 
				 }
				 
		   		  
		         
		     })
		   
		   
		  },
		 
		//编辑
		goback() {
			this.$router.push({ path: '/engineeringProject'})
		 
		},
		

      }
    }
    </script>

    <style scoped>
	.listout{
		width: 96%;
		display: flex;
		margin: 0 auto;
		margin-top: 20px;
		font-size: 14px;
	}
	.list{
		width: 25%;
		height: 20px;
		line-height: 20px;
		text-align: left;
	}
	.lists{
		width: 100%;
		display: flex;
	}
	.imglist{
		margin-right: 10px;
	}
	.titlelist{
		margin: 0 auto;
		height: 30px;
		text-align: left;
		line-height: 30px;
		margin-top: 40px;
		padding-left: 10px;
		width: 96%;
		position: relative;
	}
	.icons{
		height: 22px;
		width: 4px;
		border-radius: 10px;
		background-color: #000;
		position: absolute;
		left: 0;
		top: 4px;
	}
    .user-search {
		position: absolute;
		top: 20px;
		right: 0px;
		width: 100px;
    }
	.user-searchs {
	  margin-top: 20px;
	}
    .userRole {
      width: 100%;
    }
    .main{
    	background-color: #fff;
    	padding: 30px;
    	border-radius: 10px;
    }
    /* .avatar-uploader{
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
    } */
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9 !important;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
  
  .editForm{
	  margin: 0 auto;
	  margin-top: 30px;
	  width: 600px;
	  
  }
  .el-select{
	  width: 100%;
  }
  .dialog-footer{
	  margin: 0 auto;
	  margin-top: 30px;
	  width: 480px;
	  padding-left: 120px;
  }
  .title{
	  width: 100%;
  }
  .tableout{
	  width: 95%;
	  height: 120px;
	  border: 1px solid #d9d9d9;
	  border-radius: 5px;
	  font-size: 14px;
  }
  .tablelist{
	  width: 100%;
	  height: 40px;
	  line-height: 40px;
	  text-align: center;
	  
  }
  .tablelists{
  	  width: 100%;
  	  height: 40px;
  	  line-height: 40px;
  	  text-align: center;
  	  display: flex;
  	  
  }
  .tabletitle{
	  width: 100%;
	  height: 40px;
	  line-height: 40px;
	  text-align: center;
	  display: flex;
	  background-color: #ebe8e8;
  }
  .tabileleft{
	  width: 50%;
	  text-align: center;
	  
  }
  .tabileright{
	  width: 50%;
	  text-align: center;
  }
  .liststable{
  	width: 25%;
  }
  .listouts{
  	width: 96%;
  	display: flex;
  	margin: 0 auto;
  	margin-top: 20px;
  }
  .imglist img{
	  width: 150px;
	  height: 150px;
  }
  .imgUrls{
  	  width: 100%;
  	  height: auto;
  }
    </style>





// WEBPACK FOOTER //
// src/views/assessment/engineeringProjectadd.vue